import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "parent", "parentTitle", 
    "child", "childTitle", 
    "bulkParent", "bulkChild",

    // table and template
    "siteAllowTbody",
    "siteAllowEmpty",
    "projectAllowTemplate",
    "bulkParentTbody",
    "bulkParentRowTemplate",
    "bulkChildTbody",
    "bulkChildRowTemplate"
  ]

  connect() {
    this.hideAll()

    this._siteAllowEmptyRow = this.hasSiteAllowEmptyTarget ? this.siteAllowEmptyTarget : null
  }

  open(event) {
    const name = event.currentTarget.dataset.modalName
    if (!name) return

    this.hideAll()

    const target = this[`${name}Target`]
    const mode = event.currentTarget.dataset.modalMode

    if (!target) {
      console.warn(`Missing modal target: ${name}`)
      return
    } 

    if (name === "parent" && this.hasParentTitleTarget) {
      this.parentTitleTarget.textContent = mode === "create" ? "親事業 新規追加" : "親事業 編集"
    } else if (name === "child" && this.hasChildTitleTarget) {
      this.childTitleTarget.textContent = mode === "create" ? "子事業 新規追加" : "子事業 編集"
    }

    target.classList.remove("hidden")
  }

  close() {
    this.hideAll()
  }

  hideAll() {
    if (this.hasParentTarget){ this.parentTarget.classList.add("hidden") }
    if (this.hasChildTarget){ this.childTarget.classList.add("hidden") }
    if (this.hasBulkParentTarget){ this.bulkParentTarget.classList.add("hidden") }
    if (this.hasBulkChildTarget){ this.bulkChildTarget.classList.add("hidden") }
  }

  removeRow(event) {
    const button = event.currentTarget;
    const row = button.closest("tr");
    if (row) {
      row.remove();
    }

    const dataRows = this.siteAllowTbodyTarget.querySelectorAll("tr[data-index]");

    if (dataRows.length === 0 && this._siteAllowEmptyRow) {
      this.siteAllowTbodyTarget.appendChild(this._siteAllowEmptyRow);
    }
  }

  addProjectAllowRow() {
    const clone = this.projectAllowTemplateTarget.content.cloneNode(true)
    this.siteAllowTbodyTarget.appendChild(clone)

    if (this._siteAllowEmptyRow?.isConnected) {
      this._siteAllowEmptyRow.remove()
    }
  }

  addBulkParentRow() {
    const clone = this.bulkParentRowTemplateTarget.content.cloneNode(true);
    this.bulkParentTbodyTarget.appendChild(clone);
  }

  addBulkChildRow() {
    const clone = this.bulkChildRowTemplateTarget.content.cloneNode(true);
    this.bulkChildTbodyTarget.appendChild(clone);
  }
}
